import React from 'react'

import logo from 'assets/integrations/shopify.png'

import NavigatableIntegrationWidgetCard from '../NavigatableIntegrationWidgetCard'
import ShopifyDetail from './ShopifyDetail'
import ShopifyIndex from './ShopifyIndex'

export default function ShopifyView({
  id,
  doHideCard,
  data,
  isLoading,
  name,
  onReload,
  fetchEvents,
}) {
  return (
    <NavigatableIntegrationWidgetCard
      data={data}
      detailComponent={ShopifyDetail}
      doHideCard={doHideCard}
      image={logo}
      indexComponent={ShopifyIndex}
      isLoading={isLoading}
      title={name || 'Shopify'}
      persistenceKey={`shopify-${id}`}
      refreshable
      onRefresh={onReload}
      fetchEvents={fetchEvents}
    />
  )
}
